import * as commonScripts from '../common'

const cmpFundAlert = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    const showAlert = Boolean(_.component.getAttribute('data-show-alert'))

    if (showAlert) {
      _.changeColors(_.component)

      // Adjust page padding to match header
      commonScripts.util.syncHeaderOffset()

      // Alert msg click handler
      const alertMsg = _.component.querySelector('.cmp-fund-alert__alert-msg')
      const alertMsgBody = _.component.querySelector(
        '.cmp-fund-alert__alert-msg__body'
      )
      const alertMsgCavet = _.component.querySelector(
        '.cmp-fund-alert__alert-msg__cavet'
      )
      alertMsg.addEventListener('click', function (e) {
        alertMsgBody.classList.toggle('active')
        alertMsgCavet.classList.toggle('active')
      })
    } else {
      _.component.classList.add('d-none')
    }
  },

  changeColors: function (component) {
    const backgroundColor = component.getAttribute('data-background-color')
    const textColor = component.getAttribute('data-text-color')

    if (backgroundColor !== '') {
      component.style.backgroundColor = backgroundColor
    }

    if (textColor !== '') {
      component.querySelector('.cmp-fund-alert__alert-msg__title').style.color =
        textColor
    }
  }
}
export default cmpFundAlert
